require('babel-polyfill')
require('./polyfills')
require('./directives')
require('./components')
require('./app')
